<template>
  <IndustryDetailRender :indSlug="slug"/>
</template>
<script>
import IndustryDetailRender from './IndustryDetailRender'

export default {
  name: 'IndustryDetail',
  props: {
    slug: {
      type: String
    }
  },
  components: {
    IndustryDetailRender
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/industries/IndustryDetail.vue